import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/layout"
import { GUIDES } from "../../data/guides"

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })

const seo = {
  title: "Guides to quiet, focused offices",
  description:
    "Practical guides from VibraHub on office phone booths and meeting pods: planning permission, sound insulation ratings, how many booths you need and where to put them.",
}

const GuidesIndex = () => (
  <Layout seo={seo}>
    <div className="breadcrumb-area">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="row breadcrumb_box  align-items-center">
              <div className="col-lg-6 col-md-6 col-sm-6 text-center text-sm-left">
                <h1 className="breadcrumb-title">Guides</h1>
              </div>
              <div className="col-lg-6  col-md-6 col-sm-6">
                <ul className="breadcrumb-list text-center text-sm-right">
                  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                  <li className="breadcrumb-item active">Guides</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="site-wrapper-reveal border-bottom">
      <div className="container section-space--pb_120">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <p className="guide-article section-space--mt_30">
              Short, practical answers to the questions we get asked before an order: what the rules are, what the numbers mean, and how to size a quiet space for a real team. Written by the people who design and make Vibra booths.
            </p>
            <div className="section-space--mt_30">
              {GUIDES.map((g) => (
                <Link to={`/guides/${g.slug}/`} className="guide-card" key={g.slug}>
                  <h3>{g.title}</h3>
                  <p>{g.excerpt}</p>
                  <p className="guide-meta">Updated {formatDate(g.updated)} · {g.readingTime}</p>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default GuidesIndex
